var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-edit",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "icon-edit",
    "data-name": "Rectangle 275",
    width: 26,
    height: 26,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-edit-path",
    "data-name": "Path 2829",
    d: "M9.411,10.066a.4.4,0,0,1-.144-.028.376.376,0,0,1-.231-.362c.005-.159-.01-1.571-1.91-1.84a.375.375,0,0,1-.21-.639S11.33,2.874,13.763.549a1.712,1.712,0,0,1,2.13-.307,1.675,1.675,0,0,1,.818,1.126c.006.027.039.173.039.2v.313a2.257,2.257,0,0,1-.694,1.261c-2.25,2.347-6.329,6.757-6.37,6.8a.375.375,0,0,1-.275.12M7.93,7.255A2.609,2.609,0,0,1,9.652,8.879c1.176-1.269,4.086-4.4,5.862-6.254a1.54,1.54,0,0,0,.491-.8l0-.253a1.017,1.017,0,0,0-.478-.676.966.966,0,0,0-1.24.2C12.342,2.944,9.145,6.067,7.93,7.255M4.174,14.632c-.15,0-.3-.005-.455-.016a5.428,5.428,0,0,1-2.434-.726,2.845,2.845,0,0,1-1.258-1.4.375.375,0,0,1,.231-.5l.212-.068c.161-.053.318-.1.473-.159a3.266,3.266,0,0,0,1.78-1.454,3.971,3.971,0,0,1,1-1.214,3.2,3.2,0,0,1,2.5-.667,2.542,2.542,0,0,1,2.066,1.8,3.035,3.035,0,0,1-1.425,3.7,5.209,5.209,0,0,1-2.69.7m-.4-.764a4.563,4.563,0,0,0,2.713-.583,2.308,2.308,0,0,0,1.1-2.807A1.806,1.806,0,0,0,6.1,9.173,2.451,2.451,0,0,0,4.171,9.7a3.315,3.315,0,0,0-.805,1c2.719,1.224-.185,2.469.4,3.17",
    transform: "translate(4.625 5.684)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.8e296f5c60c3133159a7e9821c638753.svg";
export { ForwardRef as ReactComponent };